import { c as _c } from "react-compiler-runtime";
import { createContext, useContext } from 'react';
import { infiniteScrollDisabled, isInfiniteScrollEnabled } from '../../infiniteScroll/config';
import { jsx as _jsx } from "react/jsx-runtime";
const InfiniteScrollContext = /*#__PURE__*/createContext(infiniteScrollDisabled);
export const ProvideInfiniteScroll = t0 => {
  const $ = _c(3);
  const {
    children,
    config
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== config) {
    t1 = /*#__PURE__*/_jsx(InfiniteScrollContext.Provider, {
      value: config,
      children: children
    });
    $[0] = children;
    $[1] = config;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useInfiniteScrollConfig = () => {
  return useContext(InfiniteScrollContext);
};
export const useIsInfiniteScrollEnabled = () => {
  const $ = _c(2);
  const t0 = useContext(InfiniteScrollContext);
  let t1;
  if ($[0] !== t0) {
    t1 = isInfiniteScrollEnabled(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};